import { render, staticRenderFns } from "./SeletorBusca.vue?vue&type=template&id=9a731638&scoped=true"
import script from "./SeletorBusca.vue?vue&type=script&lang=js"
export * from "./SeletorBusca.vue?vue&type=script&lang=js"
import style0 from "./SeletorBusca.vue?vue&type=style&index=0&id=9a731638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a731638",
  null
  
)

export default component.exports